var map = {
	"./Intellipure-468.png": "./src/assets/Intellipure-468.png",
	"./Intellipure-950P.png": "./src/assets/Intellipure-950P.png",
	"./Intellipure-Compact.png": "./src/assets/Intellipure-Compact.png",
	"./index.css": "./src/assets/index.css",
	"./svg/american-flag-icon.svg": "./src/assets/svg/american-flag-icon.svg",
	"./svg/background-lines.svg": "./src/assets/svg/background-lines.svg",
	"./svg/building-icon.svg": "./src/assets/svg/building-icon.svg",
	"./svg/canadian-flag-icon.svg": "./src/assets/svg/canadian-flag-icon.svg",
	"./svg/current-calendar-icon.svg": "./src/assets/svg/current-calendar-icon.svg",
	"./svg/delos-logo.svg": "./src/assets/svg/delos-logo.svg",
	"./svg/duration-icon.svg": "./src/assets/svg/duration-icon.svg",
	"./svg/filter-icon.svg": "./src/assets/svg/filter-icon.svg",
	"./svg/icons-top.svg": "./src/assets/svg/icons-top.svg",
	"./svg/logo-dark.svg": "./src/assets/svg/logo-dark.svg",
	"./svg/logo-grayscale-dark.svg": "./src/assets/svg/logo-grayscale-dark.svg",
	"./svg/mask-icon.svg": "./src/assets/svg/mask-icon.svg",
	"./svg/oa-icon.svg": "./src/assets/svg/oa-icon.svg",
	"./svg/occupancy-icon.svg": "./src/assets/svg/occupancy-icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";